// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.provider-container {
  margin-left: 14%;
  margin-top: 0;
}

.provider-container .provider {
  background-color: #ffffff;
  margin-top: 10px;
  padding: 20px 60px 15px 15px;
}

.provider h1 {
  color: #a0a0a0;
  font-size: 16px;
  font-weight: 400;
}

.provider .actions {
  display: flex;
  margin-top: 40px;
}

.provider .actions .btn-provider {
  background-color: #0981fd;
  border-radius: 4px;
  border: none;
  color: #ffffff;
  margin-right: auto;
}

.provider .actions .btn-refresh {
  background-color: transparent;
  border: 1px solid #060d27;
  border-radius: 4px;
  color: #000000;
}

.provider table {
  margin-top: 30px;
}

.provider table thead {
  background-color: #f5f5f5;
  border: 1px solid #e6e6e6;
}

.provider .table-striped > tbody > tr:nth-of-type(odd) {
  background-color: transparent;
}

.provider .table-borderless > :not(caption) > * > * {
  border-bottom-width: thin;
  border-color: #f8f8f8;
}

.provider table th {
  /* font-size: 12px; */
  font-weight: 100;
}

.provider table td {
  /* font-size: 12px; */
  color: #6a6a6a;
  text-transform: uppercase;
  padding: 10px 5px;
  width: 300px;
  border-style: solid !important;
}

.provider table tbody,
td,
tfoot,
th,
thead,
tr {
  border-style: solid;
}

.provider .table > :not(:last-child) > :last-child > * {
  border-bottom-color: #ede9e9;
}

.switch {
  position: relative;
  display: inline-block;
  width: 48px;
  height: 20px;
}

.switch .span {
  color: #ffffff;
}

.checkbox {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 1.6px solid #bbb;
  border-radius: 10px;
  transition: all 0.3s ease-in 0s;
  height: 19px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 15px;
  width: 22px;
  left: 2px;
  bottom: 1px;
  /* border: 1px solid #6E6E6E; */
  background-color: #505050;
  border-radius: 8px;
  transition: 0.9s;
}

.checkbox:checked + .slider {
  border: 1.6px solid #106745;
}

.checkbox:checked + .slider:before {
  transform: translateX(30px);
  background-color: #106745;
  left: -8px !important;
}

.provider .toggle-switch .inner {
  display: block;
  width: 200%;
  margin-left: -100%;
  transition: margin 0.3s ease-in 0s;
}

.provider .inner:before,
.inner:after {
  float: left;
  width: 50%;
  height: 25px;
  padding: 0;
  padding-top: 6px;
  line-height: 10px;
  font-weight: 300;
  font-size: 8px;
  box-sizing: border-box;
}
.provider .inner:before {
  content: "ON";
  padding-left: 7px;
  color: #106745;
}
.provider .inner:after {
  content: "OFF";
  padding-right: 4px;
  background-color: transparent;
  color: #000000;
  text-align: right;
}

.provider .checkbox:checked + .label .inner {
  margin-left: 0;
}
.provider .checkbox:checked + .label .switch {
  right: 0px;
}

.provider-btn {
  border-radius: 2px;
  padding: 8px 22px;
  font-size: 12px;
}

.provider-container .btn-cancel {
  background-color: transparent;
  border: 1px solid #c1bcbc;
  margin-right: auto;
}

.provider-container .btn-save {
  background-color: #4d68c9;
  border: none;
  color: #ffffff;
}

.add-provider {
  width: 450px;
}

.add-provider .custom-select .dropdown {
  text-align: start;
}

.provider-container .service-logo {
  background-repeat: no-repeat;
  background-size: cover;
  height: 25px;
  width: 25px;
  border-radius: 50%;
}
`, "",{"version":3,"sources":["webpack://./src/view/reporting-dashboard/providers/Providers.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,YAAY;EACZ,8BAA8B;AAChC;;AAEA;;;;;;EAME,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,wBAAwB;EACxB,mBAAmB;EACnB,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,+BAA+B;EAC/B,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;;EAEE,WAAW;EACX,UAAU;EACV,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,6BAA6B;EAC7B,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB","sourcesContent":[".provider-container {\n  margin-left: 14%;\n  margin-top: 0;\n}\n\n.provider-container .provider {\n  background-color: #ffffff;\n  margin-top: 10px;\n  padding: 20px 60px 15px 15px;\n}\n\n.provider h1 {\n  color: #a0a0a0;\n  font-size: 16px;\n  font-weight: 400;\n}\n\n.provider .actions {\n  display: flex;\n  margin-top: 40px;\n}\n\n.provider .actions .btn-provider {\n  background-color: #0981fd;\n  border-radius: 4px;\n  border: none;\n  color: #ffffff;\n  margin-right: auto;\n}\n\n.provider .actions .btn-refresh {\n  background-color: transparent;\n  border: 1px solid #060d27;\n  border-radius: 4px;\n  color: #000000;\n}\n\n.provider table {\n  margin-top: 30px;\n}\n\n.provider table thead {\n  background-color: #f5f5f5;\n  border: 1px solid #e6e6e6;\n}\n\n.provider .table-striped > tbody > tr:nth-of-type(odd) {\n  background-color: transparent;\n}\n\n.provider .table-borderless > :not(caption) > * > * {\n  border-bottom-width: thin;\n  border-color: #f8f8f8;\n}\n\n.provider table th {\n  /* font-size: 12px; */\n  font-weight: 100;\n}\n\n.provider table td {\n  /* font-size: 12px; */\n  color: #6a6a6a;\n  text-transform: uppercase;\n  padding: 10px 5px;\n  width: 300px;\n  border-style: solid !important;\n}\n\n.provider table tbody,\ntd,\ntfoot,\nth,\nthead,\ntr {\n  border-style: solid;\n}\n\n.provider .table > :not(:last-child) > :last-child > * {\n  border-bottom-color: #ede9e9;\n}\n\n.switch {\n  position: relative;\n  display: inline-block;\n  width: 48px;\n  height: 20px;\n}\n\n.switch .span {\n  color: #ffffff;\n}\n\n.checkbox {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border: 1.6px solid #bbb;\n  border-radius: 10px;\n  transition: all 0.3s ease-in 0s;\n  height: 19px;\n}\n\n.slider:before {\n  position: absolute;\n  content: \"\";\n  height: 15px;\n  width: 22px;\n  left: 2px;\n  bottom: 1px;\n  /* border: 1px solid #6E6E6E; */\n  background-color: #505050;\n  border-radius: 8px;\n  transition: 0.9s;\n}\n\n.checkbox:checked + .slider {\n  border: 1.6px solid #106745;\n}\n\n.checkbox:checked + .slider:before {\n  transform: translateX(30px);\n  background-color: #106745;\n  left: -8px !important;\n}\n\n.provider .toggle-switch .inner {\n  display: block;\n  width: 200%;\n  margin-left: -100%;\n  transition: margin 0.3s ease-in 0s;\n}\n\n.provider .inner:before,\n.inner:after {\n  float: left;\n  width: 50%;\n  height: 25px;\n  padding: 0;\n  padding-top: 6px;\n  line-height: 10px;\n  font-weight: 300;\n  font-size: 8px;\n  box-sizing: border-box;\n}\n.provider .inner:before {\n  content: \"ON\";\n  padding-left: 7px;\n  color: #106745;\n}\n.provider .inner:after {\n  content: \"OFF\";\n  padding-right: 4px;\n  background-color: transparent;\n  color: #000000;\n  text-align: right;\n}\n\n.provider .checkbox:checked + .label .inner {\n  margin-left: 0;\n}\n.provider .checkbox:checked + .label .switch {\n  right: 0px;\n}\n\n.provider-btn {\n  border-radius: 2px;\n  padding: 8px 22px;\n  font-size: 12px;\n}\n\n.provider-container .btn-cancel {\n  background-color: transparent;\n  border: 1px solid #c1bcbc;\n  margin-right: auto;\n}\n\n.provider-container .btn-save {\n  background-color: #4d68c9;\n  border: none;\n  color: #ffffff;\n}\n\n.add-provider {\n  width: 450px;\n}\n\n.add-provider .custom-select .dropdown {\n  text-align: start;\n}\n\n.provider-container .service-logo {\n  background-repeat: no-repeat;\n  background-size: cover;\n  height: 25px;\n  width: 25px;\n  border-radius: 50%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
